import FeedbackComponent from "../FeedbackComponent.vue";

export default [
  {
    path: "/feedback",
    name: "Feedback",
    meta: { layout: "default" },
    component: FeedbackComponent,
  },
];
